import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default {
  actions: {
    async getPatientByPatientId({ state }, patientId) {
      return (await Vue.http.get(this.state.baseUrl + '/patientdetails/' + patientId)).data
    },
    async searchPatients({ state }, options) {
      return (await Vue.http.get(this.state.baseUrl + '/patient/_search?pageSize=' + (options.pageSize || 5) + '&query=' + options.query)).data
    },
    async searchPatient({ state }, options) {
      return (await Vue.http.get(this.state.baseUrl + '/patient/_search?query=' + options.query)).data
    },
    async createPatient({ state }, patient) {
      return (await Vue.http.post(this.state.baseUrl + '/patients', patient)).data
    },
    async getPatient({ state }, patientId) {
      return (await Vue.http.get(this.state.baseUrl + '/patients/' + patientId)).data
    },
    async updatePatient({ state }, patient) {
      return (await Vue.http.put(this.state.baseUrl + '/patients/' + patient._id, patient))
    },
    async getPatientsByCaregroups({ state }, options) {
      return (await Vue.http.post(this.state.baseUrl + '/patients/byCaregroups?pageNumber=' + options.patientListpagination.pageNumber + '&pageSize=' + options.patientListpagination.pageSize, {
        caregroups: options.caregroups,
      })).data
    },
    async searchPatientsByCaregroups({ state }, options) {
      return (await Vue.http.post(this.state.baseUrl + '/patients/search/inCaregroups?pageNumber=' + options.patientListpagination.pageNumber + '&pageSize=' + options.patientListpagination.pageSize, {
        caregroups: options.caregroups,
        searchStr: options.searchStr
      })).data
    },
    //Patients History
    async getVitalHistory({ state }, options) {
      let historicVitals = {}
      try {
        if (options.vitals) {
          for (let vital of options.vitals) {
            //API call for graph data
            let resp = await Vue.http.post(this.state.baseUrl + '/vitalsdata/_filter', {
              patientId: options.patientId,
              vitalId: vital.identifier,
              fromTime: options.fromTime,
              toTime: options.toTime
            })

            if (resp.data) {
              historicVitals[vital.identifier] = []
              resp.data.forEach((res) => {
                historicVitals[vital.identifier].push({
                  value: res.value,
                  timestamp: res.timestamp
                })
              })
            }
          }


          return historicVitals

        } else {
          for (var index in options.deviceProfile) {
            for (var vitalIndex in options.deviceProfile[index].vitals) {
              let vital = options.deviceProfile[index].vitals[vitalIndex]
              //API call for graph data
              let resp = await Vue.http.post(this.state.baseUrl + '/vitalsdata/_filter', {
                patientId: options.patientId,
                vitalId: vital.identifier,
                fromTime: options.fromTime,
                toTime: options.toTime
              })

              if (resp.data) {
                historicVitals[vital.identifier] = []
                resp.data.forEach((res) => {
                  historicVitals[vital.identifier].push({
                    value: res.value,
                    timestamp: res.timestamp
                  })
                })
              }
            }
          }

          return historicVitals

        }
      } catch (e) {
        console.log(e)
      }
    },
    async getFilesHistory({ state }, patientId) {
      try {
        let query = {
          patientId: patientId
        }
        return (await Vue.http.post(this.state.baseUrl + '/patientfiles/_filter', query)).data
      } catch (e) {
        console.log(e)
      }
    },
    async getPrescriptionsHistory({ state }, options) {
      if (options.pagination) {
        return (await Vue.http.get(this.state.baseUrl + '/patientdetails/' + options.patientId + '/notes' + '?pageNumber=' + options.pagination.pageNumber + '&pageSize=' + options.pagination.pageSize)).data
      } else {
        return (await Vue.http.get(this.state.baseUrl + '/patientdetails/' + options.patientId + '/notes')).data
      }
    },
  }
}
